// import React, { useState } from "react";
// import { Helmet } from "react-helmet-async";
// import { Button, Container, Stack, Typography } from "@mui/material";
// import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";

// import { Url } from "../url/url"; 
// import axios from "axios";
// import { categorydata } from '../redux/slice/category'
// import { useNavigate } from 'react-router-dom';
// import {useDispatch} from 'react-redux'
// import Swal from "sweetalert2";


// import { ToastContainer, toast } from 'react-toastify';
//   import 'react-toastify/dist/ReactToastify.css';

// const CategoryPage = () => {
//   const dispatch = useDispatch()
//   const navigate = useNavigate()
//   const categoryAllData = useSelector((store) => store.category.data);
//   const [category, setCategory]= useState()
//   const [color, setColor]= useState("tranparent")
//   const [deleteLoading, setDeleteLoading]= useState()

//   const formHandle = (e)=>{
//     setColor("green")
//     const categoryValue = (e.target.value).toLowerCase()  
//     setCategory(categoryValue);
//     if((e.target.value).length < 1){
//       setColor("red")
//     }
//   } 
 

//   const deleteCategory = async (e, id)=>{ 
//     e.preventDefault();
//     setDeleteLoading(true)
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async(result) => {
//       if (result.isConfirmed) {
//         try {
//           const hhh = await axios.delete(`${Url}/category/delete/${id}`)  
//           dispatch(categorydata()) 
//           toast.success('Package delete successfully', {
//             position: "top-right",
//             autoClose: 1500,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: false,
//             draggable: true,
//             progress: undefined,
//             theme: "light",
//           });
//           setDeleteLoading(false)
//         } catch (error) {
//           setDeleteLoading(false)
//           toast.error('Something went wrong', {
//             position: "top-right",
//             autoClose: 1500,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: false,
//             draggable: true,
//             progress: undefined,
//             theme: "light",
//             });
//         }  
//       }
//       setDeleteLoading(false)
//     })
//     setDeleteLoading(false)
//   }

//   const addCategory = async(e)=>{
    
//     e.preventDefault();
//     try {
//       if(category){
//         try {
//           await axios.post(`${Url}/category/add`, {category})
//           dispatch(categorydata())
//           setCategory("")
//           toast.success("New Package Added");   
//         } catch (error) {
//           console.log(error);
//           toast.error("something went wrong");  
//         } 
//       }
//       else{
//         setColor("red")
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   return (
//     <>
//     <ToastContainer />
//       <Helmet>
//         <title> Dashboard: Products | Minimal UI </title>
//       </Helmet>
//       {/* <Container>
//         <Stack
//           direction="row"
//           alignItems="center"
//           justifyContent="space-between"
//           mb={3}
//         >
//           <Typography variant="h4" gutterBottom>
//             Category
//           </Typography>
//         </Stack>
//       </Container>

//       <Container className="mb-4">
//         <form action="">
//           <div className="card p-3">
//             <div className="d-flex justify-content-between ">
//               <div>
//                 <h3 className="text-primary">Add New Category</h3>
//               </div>
//               <div className="d-flex">
//                 <div className="form-group me-3">
//                   <input type="text" name="" id="" value={category} style={{borderColor : color}} onChange={e=>formHandle(e)}  className="form-control" />

//                 </div>
//                 <div>
//                   <button type="submit" onClick={e=>addCategory(e)} className="btn btn-primary">Add New Category</button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       </Container>

//       <Container className=" ">
//         <div className="d-flex align-items-center justify-content-end felx-wrap bg-lightgray rounded-top p-3">
    
//           <div>
//             <div className="d-flex align-items-center ">
//               <p className="mb-0 me-2 ">All Category : </p>
//               <h4 className="text-primary fw-bold mb-0">
//                 {categoryAllData.length}
//               </h4>
//             </div>
//           </div>
//         </div>
//       </Container>
//       <Container>
//         <section className="table-responsive">
//           <table className="table table-striped table-bordered text-center table-hover align-top">
//             <thead className="table-primary">
//               <tr className="align-top">
//                 <th>S. No.</th>
//                 <th>Category</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {categoryAllData.map((cv, i) => {
//                 return (
//                   <tr className="text-center" key={i}>
//                     <td>{i + 1}</td>
//                     <td className="">{cv.category}</td>
//                     <td>
//                       <div className="d-flex align-items-center justify-content-center">
             
//                         <button className="btn border-0 text-danger me-3" onClick={e=>deleteCategory(e, cv._id)}>
//                         <i className="fa-solid fa-trash fa-sm text-danger"></i> <small>{deleteLoading ? <>deleting</> : <>delete</>} </small>
//                         </button>
                  
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </section>
//       </Container> */}

// <Container>

//   <div className="d-flex justify-content-between align-items-center mb-4">
//     <h3 className="fw-bold text-dark m-0">📁 Manage Categories</h3>
//     <span className="badge bg-primary fs-6 px-3 py-2 shadow-sm rounded-3">
//       Total: {categoryAllData.length}
//     </span>
//   </div>


//   <div className="card border-0 shadow-sm mb-4 p-4 category-add-ui rounded-4">
//     <h5 className="text-primary fw-bold mb-3">➕ Add New Category</h5>
//     <form onSubmit={(e) => addCategory(e)}>
//       <div className="row g-2">
//         <div className="col-md-9">
//           <input
//             type="text"
//             value={category}
//             onChange={(e) => formHandle(e)}
//             className="form-control border-primary"
//             placeholder="Enter category name"
//             style={{ borderColor: color }}
//           />
//         </div>
//         <div className="col-md-3 d-grid">
//           <button type="submit" className="btn btn-primary">
//             <i className="fa fa-plus me-2"></i>Add Category
//           </button>
//         </div>
//       </div>
//     </form>
//   </div>

 
//   <div className="card border-0 shadow-sm p-3 category-table-ui rounded-4">
//     <div className="table-responsive">
//       <table className="table table-hover table-striped align-middle text-center mb-0">
//         <thead className="table-dark">
//           <tr>
//             <th style={{ width: '10%' }}>S. No.</th>
//             <th style={{ width: '60%' }}>Category</th>
//             <th style={{ width: '30%' }}>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {categoryAllData.map((cv, i) => (
//             <tr key={i}>
//               <td>{i + 1}</td>
//               <td className="text-capitalize fw-semibold">{cv.category}</td>
//               <td>
//                 <button
//                   className="btn btn-outline-danger btn-sm d-flex align-items-center justify-content-center gap-2 mx-auto"
//                   onClick={(e) => deleteCategory(e, cv._id)}
//                 >
//                   <i className="fa fa-trash"></i>
//                   {deleteLoading ? 'Deleting...' : 'Delete'}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// </Container>


//     </>
//   );
// };

// export default CategoryPage;





// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet-async";
// import { Container } from "@mui/material";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from 'react-router-dom';
// import axios from "axios";
// import Swal from "sweetalert2";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Url } from "../url/url";
// import { categorydata } from '../redux/slice/category';

// const CategoryPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const categoryAllData = useSelector((store) => store.category.data);
//   const [category, setCategory] = useState("");
//   const [color, setColor] = useState("transparent");
//   const [deleteLoading, setDeleteLoading] = useState(false);


//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 4;

//   useEffect(() => {
//     dispatch(categorydata());
//   }, [dispatch]);

//   const formHandle = (e) => {
//     const categoryValue = e.target.value.toLowerCase();
//     setCategory(categoryValue);
//     setColor(categoryValue.length > 0 ? "green" : "red");
//   };

//   const addCategory = async (e) => {
//     e.preventDefault();
//     if (!category) return setColor("red");

//     try {
//       await axios.post(`${Url}/category/add`, { category });
      
//       dispatch(categorydata());
//       setCategory("");
//       toast.success("New Category Added");
//     } catch (error) {
//       console.log(error);
//       toast.error("Something went wrong");
//     }
//   };

//   const deleteCategory = async (e, id) => {
//     e.preventDefault();
//     setDeleteLoading(true);

//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(`${Url}/category/delete/${id}`);
//           dispatch(categorydata());
//           toast.success('Category deleted successfully');
//         } catch (error) {
//           toast.error('Something went wrong');
//         }
//       }
//       setDeleteLoading(false);
//     });
//   };

//   // Pagination logic
//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentCategories = categoryAllData.slice(indexOfFirst, indexOfLast);
//   const totalPages = itemsPerPage > 0 ? Math.ceil(categoryAllData.length / itemsPerPage) : 1;


//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title> Dashboard: Category | Minimal UI </title>
//       </Helmet>

//       <Container>
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="fw-bold text-dark m-0">📁 Manage Categories</h3>
//           <span className="badge bg-primary fs-6 px-3 py-2 shadow-sm rounded-3">
//             Total: {categoryAllData.length}
//           </span>
//         </div>

//         <div className="card border-0 shadow-sm mb-4 p-4 category-add-ui rounded-4">
//           <h5 className="text-primary fw-bold mb-3">➕ Add New Category</h5>
//           <form onSubmit={addCategory}>
//             <div className="row g-2">
//               <div className="col-md-9">
//                 <input
//                   type="text"
//                   value={category}
//                   onChange={formHandle}
//                   className="form-control border-primary"
//                   placeholder="Enter category name"
//                   style={{ borderColor: color }}
//                 />
//               </div>
//               <div className="col-md-3 d-grid">
//                 <button type="submit" className="btn btn-primary">
//                   <i className="fa fa-plus me-2"></i>Add Category
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         <div className="card border-0 shadow-sm p-3 category-table-ui rounded-4">
//           <div className="table-responsive">
//             <table className="table table-hover table-striped align-middle text-center mb-0">
//               <thead className="table-dark">
//                 <tr>
//                   <th style={{ width: '10%' }}>S. No.</th>
//                   <th style={{ width: '60%' }}>Category</th>
//                   <th style={{ width: '30%' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentCategories.map((cv, i) => (
//                   <tr key={i}>
//                     <td>{indexOfFirst + i + 1}</td>
//                     <td className="text-capitalize fw-semibold">{cv.category}</td>
//                     <td>
//                       <button
//                         className="btn btn-outline-danger btn-sm d-flex align-items-center justify-content-center gap-2 mx-auto"
//                         onClick={(e) => deleteCategory(e, cv._id)}
//                       >
//                         <i className="fa fa-trash"></i>
//                         {deleteLoading ? 'Deleting...' : 'Delete'}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//           {/* Pagination Controls */}
// {totalPages > 1 && (
//   <nav className="mt-3">
//     <ul className="pagination justify-content-center">
//       {[...Array(totalPages)].map((_, idx) => (
//         <li
//           key={idx}
//           className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}
//           onClick={() => handlePageChange(idx + 1)}
//           style={{ cursor: "pointer" }}
//         >
//           <span className="page-link">{idx + 1}</span>
//         </li>
//       ))}
//     </ul>
//   </nav>
// )}

//           </div>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default CategoryPage;




// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet-async";
// import { Container } from "@mui/material";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from 'react-router-dom';
// import axios from "axios";
// import Swal from "sweetalert2";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Url } from "../url/url";
// import { categorydata } from '../redux/slice/category';

// const CategoryPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const categoryAllData = useSelector((store) => store.category.data);

//   const [category, setCategory] = useState("");
//   const [image, setImage] = useState(null); // ✅ image state
//   const [color, setColor] = useState("transparent");
//   const [deleteLoading, setDeleteLoading] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 4;

//   useEffect(() => {
//     dispatch(categorydata());
//   }, [dispatch]);

//   const formHandle = (e) => {
//     const categoryValue = e.target.value.toLowerCase();
//     setCategory(categoryValue);
//     setColor(categoryValue.length > 0 ? "green" : "red");
//   };

//   const addCategory = async (e) => {
//     e.preventDefault();
//     if (!category || !image) return setColor("red");

//     try {
//       const formData = new FormData();
//       formData.append("category", category);
//       formData.append("image", image);

//       await axios.post(`${Url}/category/add`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       dispatch(categorydata());
//       setCategory("");
//       setImage(null);
//       toast.success("New Category Added");
//     } catch (error) {
//       console.log(error);
//       toast.error("Something went wrong");
//     }
//   };

//   const deleteCategory = async (e, id) => {
//     e.preventDefault();
//     setDeleteLoading(true);

//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(`${Url}/category/delete/${id}`);
//           dispatch(categorydata());
//           toast.success('Category deleted successfully');
//         } catch (error) {
//           toast.error('Something went wrong');
//         }
//       }
//       setDeleteLoading(false);
//     });
//   };

//   // Pagination logic
//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentCategories = categoryAllData.slice(indexOfFirst, indexOfLast);
//   const totalPages = itemsPerPage > 0 ? Math.ceil(categoryAllData.length / itemsPerPage) : 1;

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title> Dashboard: Category | Minimal UI </title>
//       </Helmet>

//       <Container>
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="fw-bold text-dark m-0">📁 Manage Categories</h3>
//           <span className="badge bg-primary fs-6 px-3 py-2 shadow-sm rounded-3">
//             Total: {categoryAllData.length}
//           </span>
//         </div>

//         <div className="card border-0 shadow-sm mb-4 p-4 category-add-ui rounded-4">
//           <h5 className="text-primary fw-bold mb-3">➕ Add New Category</h5>
//           <form onSubmit={addCategory}>
//             <div className="row g-2">
//               <div className="col-md-5">
//                 <input
//                   type="text"
//                   value={category}
//                   onChange={formHandle}
//                   className="form-control border-primary"
//                   placeholder="Enter category name"
//                   style={{ borderColor: color }}
//                 />
//               </div>

//               <div className="col-md-5">
//                 <input
//                   type="file"
//                   className="form-control border-primary"
//                   onChange={(e) => setImage(e.target.files[0])}
//                   accept="image/*"
//                 />
//               </div>

//               <div className="col-md-2 d-grid">
//                 <button type="submit" className="btn btn-primary">
//                   <i className="fa fa-plus me-2"></i>Add Category
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         <div className="card border-0 shadow-sm p-3 category-table-ui rounded-4">
//           <div className="table-responsive">
//             <table className="table table-hover table-striped align-middle text-center mb-0">
//               <thead className="table-dark">
//                 <tr>
//                   <th style={{ width: '10%' }}>S. No.</th>
//                   <th style={{ width: '50%' }}>Category</th>
//                   <th style={{ width: '20%' }}>Image</th>
//                   <th style={{ width: '20%' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentCategories.map((cv, i) => (
//                   <tr key={i}>
//                     <td>{indexOfFirst + i + 1}</td>
//                     <td className="text-capitalize fw-semibold">{cv.category}</td>
//                     <td>
//                       {cv.image && (
//                         <img src={cv.image} alt={cv.category} style={{ width: '50px', borderRadius: '4px' }} />
//                       )}
//                     </td>
//                     <td>
//                       <button
//                         className="btn btn-outline-danger btn-sm d-flex align-items-center justify-content-center gap-2 mx-auto"
//                         onClick={(e) => deleteCategory(e, cv._id)}
//                       >
//                         <i className="fa fa-trash"></i>
//                         {deleteLoading ? 'Deleting...' : 'Delete'}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {totalPages > 1 && (
//               <nav className="mt-3">
//                 <ul className="pagination justify-content-center">
//                   {[...Array(totalPages)].map((_, idx) => (
//                     <li
//                       key={idx}
//                       className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}
//                       onClick={() => handlePageChange(idx + 1)}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <span className="page-link">{idx + 1}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </nav>
//             )}

//           </div>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default CategoryPage;



// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet-async";
// import { Container } from "@mui/material";
// import { useSelector, useDispatch } from "react-redux";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { Url } from "../url/url";
// import { categorydata } from "../redux/slice/category";

// const CategoryPage = () => {
//   const dispatch = useDispatch();
//   const categoryAllData = useSelector((store) => store.category.data);

//   const [category, setCategory] = useState("");
//   const [image, setImage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 4;

//   useEffect(() => {
//     dispatch(categorydata());
//   }, [dispatch]);

//   const formHandle = (e) => {
//     setCategory(e.target.value);
//   };

//   const addCategory = async (e) => {
//     e.preventDefault();
//     if (!category || !image) return toast.error("Please fill all fields!");

//     setLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append("category", category);
//       formData.append("image", image);

//       await axios.post(`${Url}/category/add`, formData);

//       toast.success("✅ Category Added Successfully!");

//       setCategory("");
//       setImage(null);
//       document.getElementById("fileInput").value = null;

//       dispatch(categorydata());
//     } catch (error) {
//       toast.error("❌ Something went wrong!");
//     }

//     setLoading(false);
//   };

//   const deleteCategory = async (id) => {
//     const confirmDelete = window.confirm("Are you sure to delete?");
//     if (!confirmDelete) return;

//     setDeleteLoading(id);

//     try {
//       await axios.delete(`${Url}/category/delete/${id}`);
//       toast.success("✅ Category Deleted!");
//       dispatch(categorydata());
//     } catch (error) {
//       toast.error("❌ Something went wrong!");
//     }

//     setDeleteLoading(null);
//   };

//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentCategories = categoryAllData.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(categoryAllData.length / itemsPerPage);

//   return (
//     <>
//       <ToastContainer />
//       <Helmet><title>Dashboard: Category</title></Helmet>

//       <Container>
//         <h3 className="fw-bold text-dark mb-3">📁 Manage Categories</h3>

//         <div className="card p-4 shadow-sm mb-4 rounded-4">
//           <h5 className="fw-bold text-primary mb-3">➕ Add Category</h5>
//           <form onSubmit={addCategory}>
//             <div className="row g-2">
//               <div className="col-md-5">
//                 <input
//                   type="text"
//                   value={category}
//                   onChange={formHandle}
//                   className="form-control"
//                   placeholder="Category Name"
//                 />
//               </div>

//               <div className="col-md-5">
//                 <input
//                   type="file"
//                   id="fileInput"
//                   className="form-control"
//                   onChange={(e) => setImage(e.target.files[0])}
//                   accept="image/*"
//                 />
//               </div>

//               <div className="col-md-2 d-grid">
//                 <button type="submit" className="btn btn-primary" disabled={loading}>
//                   {loading ? (
//                     <span className="spinner-border spinner-border-sm"></span>
//                   ) : (
//                     "Add"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         <div className="card shadow-sm p-3 rounded-4">
//           <table className="table align-middle text-center table-hover">
//             <thead className="table-dark">
//               <tr>
//                 <th>S No</th>
//                 <th>Category</th>
//                 <th>Image</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {currentCategories.map((cv, i) => (
//                 <tr key={cv._id}>
//                   <td>{indexOfFirst + i + 1}</td>
//                   <td className="text-capitalize fw-semibold">{cv.category}</td>
//                   <td>
//                     {cv.image && (
//                       <img src={cv.image} alt="img" width="50" className="rounded" />
//                     )}
//                   </td>
//                   <td>
//                     <button
//                       className="btn btn-outline-danger btn-sm"
//                       onClick={() => deleteCategory(cv._id)}
//                       disabled={deleteLoading === cv._id}
//                     >
//                       {deleteLoading === cv._id ? (
//                         <span className="spinner-border spinner-border-sm"></span>
//                       ) : (
//                         "Delete"
//                       )}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <ul className="pagination justify-content-center mt-3">
//             {[...Array(totalPages)].map((_, idx) => (
//               <li
//                 key={idx}
//                 className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}
//                 onClick={() => setCurrentPage(idx + 1)}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="page-link">{idx + 1}</span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default CategoryPage;












// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet-async";
// import { Container, Modal, Box, Typography, TextField, Button } from "@mui/material";
// import { useSelector, useDispatch } from "react-redux";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { Url } from "../url/url";
// import { categorydata } from "../redux/slice/category";

// const CategoryPage = () => {
//   const dispatch = useDispatch();
//   const categoryAllData = useSelector((store) => store.category.data);

//   const [category, setCategory] = useState("");
//   const [image, setImage] = useState(null);
//   const [metaTitle, setMetaTitle] = useState("");
//   const [metaDescription, setMetaDescription] = useState("");
//   const [metaKeywords, setMetaKeywords] = useState("");
//   const [showSeoFields, setShowSeoFields] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 4;

//   // ── EDIT MODAL STATE ──
//   const [open, setOpen] = useState(false);
//   const [editId, setEditId] = useState("");
//   const [editCategory, setEditCategory] = useState("");
//   const [editImage, setEditImage] = useState(null);
//   const [editExistingImage, setEditExistingImage] = useState("");
//   const [editMetaTitle, setEditMetaTitle] = useState("");
//   const [editMetaDescription, setEditMetaDescription] = useState("");
//   const [editMetaKeywords, setEditMetaKeywords] = useState("");
//   const [editLoading, setEditLoading] = useState(false);

//   useEffect(() => {
//     dispatch(categorydata());
//   }, [dispatch]);

//   const formHandle = (e) => setCategory(e.target.value);

//   const addCategory = async (e) => {
//     e.preventDefault();
//     if (!category || !image) return toast.error("Please fill all fields!");

//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("category", category);
//       formData.append("image", image);
//       formData.append("metaTitle", metaTitle);
//       formData.append("metaDescription", metaDescription);
//       formData.append("metaKeywords", metaKeywords);

//       await axios.post(`${Url}/category/add`, formData);

//       toast.success("✅ Category Added Successfully!");

//       setCategory("");
//       setImage(null);
//       setMetaTitle("");
//       setMetaDescription("");
//       setMetaKeywords("");
//       document.getElementById("fileInput").value = null;

//       dispatch(categorydata());
//     } catch (error) {
//       toast.error("❌ Something went wrong!");
//     }
//     setLoading(false);
//   };

//   const deleteCategory = async (id) => {
//     const confirmDelete = window.confirm("Are you sure to delete?");
//     if (!confirmDelete) return;

//     setDeleteLoading(id);
//     try {
//       await axios.delete(`${Url}/category/delete/${id}`);
//       toast.success("✅ Category Deleted!");
//       dispatch(categorydata());
//     } catch (error) {
//       toast.error("❌ Something went wrong!");
//     }
//     setDeleteLoading(null);
//   };

//   // ── OPEN EDIT MODAL ──
//   const openEditModal = (cv) => {
//     setEditId(cv._id);
//     setEditCategory(cv.category);
//     setEditImage(null);
//     setEditExistingImage(cv.image);
//     setEditMetaTitle(cv.metaTitle || "");
//     setEditMetaDescription(cv.metaDescription || "");
//     setEditMetaKeywords(cv.metaKeywords || "");
//     setOpen(true);
//   };

//   const closeEditModal = () => setOpen(false);

//   // ── UPDATE CATEGORY ──
//   const updateCategory = async () => {
//     if (!editCategory) return toast.error("Category name required!");

//     setEditLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("category", editCategory);
//       if (editImage) formData.append("image", editImage); // optional
//       formData.append("metaTitle", editMetaTitle);
//       formData.append("metaDescription", editMetaDescription);
//       formData.append("metaKeywords", editMetaKeywords);

//       await axios.put(`${Url}/category/update/${editId}`, formData);

//       toast.success("✅ Category Updated!");
//       closeEditModal();
//       dispatch(categorydata());
//     } catch (error) {
//       toast.error("❌ Update failed!");
//     }
//     setEditLoading(false);
//   };

//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentCategories = categoryAllData.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(categoryAllData.length / itemsPerPage);

//   return (
//     <>
//       <ToastContainer />
//       <Helmet><title>Dashboard: Category</title></Helmet>

//       <Container>
//         <h3 className="fw-bold text-dark mb-3">📁 Manage Categories</h3>

//         <div className="card p-4 shadow-sm mb-4 rounded-4">
//           <h5 className="fw-bold text-primary mb-3">➕ Add Category</h5>
//           <form onSubmit={addCategory}>
//             <div className="row g-2">
//               <div className="col-md-5">
//                 <input
//                   type="text"
//                   value={category}
//                   onChange={formHandle}
//                   className="form-control"
//                   placeholder="Category Name"
//                 />
//               </div>
//               <div className="col-md-5">
//                 <input
//                   type="file"
//                   id="fileInput"
//                   className="form-control"
//                   onChange={(e) => setImage(e.target.files[0])}
//                   accept="image/*"
//                 />
//               </div>
//               <div className="col-md-2 d-grid">
//                 <button type="submit" className="btn btn-primary" disabled={loading}>
//                   {loading ? <span className="spinner-border spinner-border-sm"></span> : "Add"}
//                 </button>
//               </div>
//             </div>

//             <div className="mt-2">
//               <button
//                 type="button"
//                 className="btn btn-sm btn-outline-secondary"
//                 onClick={() => setShowSeoFields((p) => !p)}
//               >
//                 {showSeoFields ? "Hide SEO Fields ▲" : "+ Add SEO Fields (optional)"}
//               </button>
//             </div>

//             {showSeoFields && (
//               <div className="row g-2 mt-2">
//                 <div className="col-md-4">
//                   <input type="text" value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} className="form-control" placeholder="Meta Title (optional)" />
//                 </div>
//                 <div className="col-md-4">
//                   <input type="text" value={metaDescription} onChange={(e) => setMetaDescription(e.target.value)} className="form-control" placeholder="Meta Description (optional)" />
//                 </div>
//                 <div className="col-md-4">
//                   <input type="text" value={metaKeywords} onChange={(e) => setMetaKeywords(e.target.value)} className="form-control" placeholder="Meta Keywords, comma separated (optional)" />
//                 </div>
//               </div>
//             )}
//           </form>
//         </div>

//         <div className="card shadow-sm p-3 rounded-4">
//           <table className="table align-middle text-center table-hover">
//             <thead className="table-dark">
//               <tr>
//                 <th>S No</th>
//                 <th>Category</th>
//                 <th>Image</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentCategories.map((cv, i) => (
//                 <tr key={cv._id}>
//                   <td>{indexOfFirst + i + 1}</td>
//                   <td className="text-capitalize fw-semibold">{cv.category}</td>
//                   <td>{cv.image && <img src={cv.image} alt="img" width="50" className="rounded" />}</td>
//                   <td>
//                     <button
//                       className="btn btn-sm btn-warning me-2"
//                       onClick={() => openEditModal(cv)}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       className="btn btn-outline-danger btn-sm"
//                       onClick={() => deleteCategory(cv._id)}
//                       disabled={deleteLoading === cv._id}
//                     >
//                       {deleteLoading === cv._id ? <span className="spinner-border spinner-border-sm"></span> : "Delete"}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <ul className="pagination justify-content-center mt-3">
//             {[...Array(totalPages)].map((_, idx) => (
//               <li
//                 key={idx}
//                 className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}
//                 onClick={() => setCurrentPage(idx + 1)}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span className="page-link">{idx + 1}</span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </Container>

//       {/* EDIT MODAL */}
//       <Modal open={open} onClose={closeEditModal}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 460,
//             bgcolor: "background.paper",
//             boxShadow: 24,
//             p: 4,
//             borderRadius: 3,
//             maxHeight: "90vh",
//             overflowY: "auto",
//           }}
//         >
//           <Box
//             onClick={closeEditModal}
//             sx={{
//               position: "absolute",
//               top: 10,
//               right: 10,
//               cursor: "pointer",
//               fontSize: "22px",
//               fontWeight: "bold",
//               color: "#555",
//               "&:hover": { color: "black" },
//             }}
//           >
//             ✕
//           </Box>

//           <Typography variant="h6" className="fw-bold mb-3">
//             Edit Category
//           </Typography>

//           <TextField
//             fullWidth
//             label="Category Name"
//             value={editCategory}
//             onChange={(e) => setEditCategory(e.target.value)}
//             sx={{ mb: 2 }}
//           />

//           <div className="mb-3">
//             {editExistingImage && !editImage && (
//               <img src={editExistingImage} alt="current" width="60" className="rounded mb-2 d-block" />
//             )}
//             <label className="form-label" style={{ fontSize: 13, color: "#666" }}>
//               Change Image (optional — leave empty to keep current)
//             </label>
//             <input
//               type="file"
//               accept="image/*"
//               className="form-control"
//               onChange={(e) => setEditImage(e.target.files[0])}
//             />
//           </div>

//           <Typography variant="subtitle2" className="fw-bold mb-1" sx={{ color: "#666" }}>
//             SEO Fields (optional)
//           </Typography>

//           <TextField
//             fullWidth
//             label="Meta Title"
//             value={editMetaTitle}
//             onChange={(e) => setEditMetaTitle(e.target.value)}
//             sx={{ mb: 2 }}
//           />
//           <TextField
//             fullWidth
//             label="Meta Description"
//             value={editMetaDescription}
//             onChange={(e) => setEditMetaDescription(e.target.value)}
//             multiline
//             rows={2}
//             sx={{ mb: 2 }}
//           />
//           <TextField
//             fullWidth
//             label="Meta Keywords (comma separated)"
//             value={editMetaKeywords}
//             onChange={(e) => setEditMetaKeywords(e.target.value)}
//             sx={{ mb: 2 }}
//           />

//           <Button variant="contained" fullWidth onClick={updateCategory} disabled={editLoading}>
//             {editLoading ? "Updating..." : "Update"}
//           </Button>
//         </Box>
//       </Modal>
//     </>
//   );
// };

// export default CategoryPage;












import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Modal, Box, Typography, TextField, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Url } from "../url/url";
import { categorydata } from "../redux/slice/category";

const CategoryPage = () => {
  const dispatch = useDispatch();
  const categoryAllData = useSelector((store) => store.category.data);

  const [category, setCategory] = useState("");
  const [image, setImage] = useState(null);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [showSeoFields, setShowSeoFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  // ── EDIT MODAL STATE ──
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [editCategory, setEditCategory] = useState("");
  const [editImage, setEditImage] = useState(null);
  const [editExistingImage, setEditExistingImage] = useState("");
  const [editMetaTitle, setEditMetaTitle] = useState("");
  const [editMetaDescription, setEditMetaDescription] = useState("");
  const [editMetaKeywords, setEditMetaKeywords] = useState("");
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    dispatch(categorydata());
  }, [dispatch]);

  const formHandle = (e) => setCategory(e.target.value);

  const addCategory = async (e) => {
    e.preventDefault();
    if (!category || !image) return toast.error("Please fill all fields!");

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("image", image);
      formData.append("metaTitle", metaTitle);
      formData.append("metaDescription", metaDescription);
      formData.append("metaKeywords", metaKeywords);

      await axios.post(`${Url}/category/add`, formData);

      toast.success("✅ Category Added Successfully!");

      setCategory("");
      setImage(null);
      setMetaTitle("");
      setMetaDescription("");
      setMetaKeywords("");
      document.getElementById("fileInput").value = null;

      dispatch(categorydata());
    } catch (error) {
      toast.error("❌ Something went wrong!");
    }
    setLoading(false);
  };

  const deleteCategory = async (id) => {
    const confirmDelete = window.confirm("Are you sure to delete?");
    if (!confirmDelete) return;

    setDeleteLoading(id);
    try {
      await axios.delete(`${Url}/category/delete/${id}`);
      toast.success("✅ Category Deleted!");
      dispatch(categorydata());
    } catch (error) {
      toast.error("❌ Something went wrong!");
    }
    setDeleteLoading(null);
  };

  // ── OPEN EDIT MODAL ──
  const openEditModal = (cv) => {
    setEditId(cv._id);
    setEditCategory(cv.category);
    setEditImage(null);
    setEditExistingImage(cv.image);
    setEditMetaTitle(cv.metaTitle || "");
    setEditMetaDescription(cv.metaDescription || "");
    setEditMetaKeywords(cv.metaKeywords || "");
    setOpen(true);
  };

  const closeEditModal = () => setOpen(false);

  // ── UPDATE CATEGORY ──
  const updateCategory = async () => {
    if (!editCategory) return toast.error("Category name required!");

    setEditLoading(true);
    try {
      const formData = new FormData();
      formData.append("category", editCategory);
      if (editImage) formData.append("image", editImage); // optional
      formData.append("metaTitle", editMetaTitle);
      formData.append("metaDescription", editMetaDescription);
      formData.append("metaKeywords", editMetaKeywords);

      await axios.put(`${Url}/category/update/${editId}`, formData);

      toast.success("✅ Category Updated!");
      closeEditModal();
      dispatch(categorydata());
    } catch (error) {
      toast.error("❌ Update failed!");
    }
    setEditLoading(false);
  };

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentCategories = categoryAllData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(categoryAllData.length / itemsPerPage);

  return (
    <>
      <ToastContainer />
      <Helmet><title>Dashboard: Category</title></Helmet>

      <Container>
        <h3 className="fw-bold text-dark mb-3">📁 Manage Categories</h3>

        <div className="card p-4 shadow-sm mb-4 rounded-4">
          <h5 className="fw-bold text-primary mb-3">➕ Add Category</h5>
          <form onSubmit={addCategory}>
            <div className="row g-2">
              <div className="col-md-5">
                <input
                  type="text"
                  value={category}
                  onChange={formHandle}
                  className="form-control"
                  placeholder="Category Name"
                />
              </div>
              <div className="col-md-5">
                <input
                  type="file"
                  id="fileInput"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                  accept="image/*"
                />
              </div>
              <div className="col-md-2 d-grid">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? <span className="spinner-border spinner-border-sm"></span> : "Add"}
                </button>
              </div>
            </div>

            <div className="mt-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowSeoFields((p) => !p)}
              >
                {showSeoFields ? "Hide SEO Fields ▲" : "+ Add SEO Fields (optional)"}
              </button>
            </div>

            {showSeoFields && (
              <div className="row g-2 mt-2">
                <div className="col-md-4">
                  <label className="form-label" style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    Meta Title
                  </label>
                  <input
                    type="text"
                    value={metaTitle}
                    onChange={(e) => setMetaTitle(e.target.value)}
                    className="form-control"
                    placeholder="Meta Title (optional)"
                    style={{ fontSize: 14 }}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label" style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    Meta Description
                  </label>
                  <textarea
                    value={metaDescription}
                    onChange={(e) => setMetaDescription(e.target.value)}
                    className="form-control"
                    placeholder="Meta Description (optional)"
                    rows={4}
                    style={{ fontSize: 14, lineHeight: 1.6, resize: "vertical" }}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label" style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    Meta Keywords
                  </label>
                  <textarea
                    value={metaKeywords}
                    onChange={(e) => setMetaKeywords(e.target.value)}
                    className="form-control"
                    placeholder="Meta Keywords, comma separated (optional)"
                    rows={4}
                    style={{ fontSize: 14, lineHeight: 1.6, resize: "vertical" }}
                  />
                </div>
              </div>
            )}
          </form>
        </div>

        <div className="card shadow-sm p-3 rounded-4">
          <table className="table align-middle text-center table-hover">
            <thead className="table-dark">
              <tr>
                <th>S No</th>
                <th>Category</th>
                <th>Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentCategories.map((cv, i) => (
                <tr key={cv._id}>
                  <td>{indexOfFirst + i + 1}</td>
                  <td className="text-capitalize fw-semibold">{cv.category}</td>
                  <td>{cv.image && <img src={cv.image} alt="img" width="50" className="rounded" />}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => openEditModal(cv)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => deleteCategory(cv._id)}
                      disabled={deleteLoading === cv._id}
                    >
                      {deleteLoading === cv._id ? <span className="spinner-border spinner-border-sm"></span> : "Delete"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <ul className="pagination justify-content-center mt-3">
            {[...Array(totalPages)].map((_, idx) => (
              <li
                key={idx}
                className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(idx + 1)}
                style={{ cursor: "pointer" }}
              >
                <span className="page-link">{idx + 1}</span>
              </li>
            ))}
          </ul>
        </div>
      </Container>

      {/* EDIT MODAL */}
      <Modal open={open} onClose={closeEditModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "94vw", sm: 640 },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            maxHeight: "92vh",
            overflowY: "auto",
          }}
        >
          <Box
            onClick={closeEditModal}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              cursor: "pointer",
              fontSize: "22px",
              fontWeight: "bold",
              color: "#555",
              "&:hover": { color: "black" },
            }}
          >
            ✕
          </Box>

          <Typography variant="h5" className="fw-bold mb-3">
            Edit Category
          </Typography>

          <TextField
            fullWidth
            label="Category Name"
            value={editCategory}
            onChange={(e) => setEditCategory(e.target.value)}
            sx={{ mb: 3 }}
            InputProps={{ style: { fontSize: 16 } }}
          />

          <div className="mb-4">
            {editExistingImage && !editImage && (
              <img src={editExistingImage} alt="current" width="70" className="rounded mb-2 d-block" />
            )}
            <label className="form-label" style={{ fontSize: 14, color: "#666" }}>
              Change Image (optional — leave empty to keep current)
            </label>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={(e) => setEditImage(e.target.files[0])}
            />
          </div>

          <Typography variant="subtitle1" className="fw-bold mb-2" sx={{ color: "#444" }}>
            SEO Fields (optional)
          </Typography>

          <TextField
            fullWidth
            label="Meta Title"
            value={editMetaTitle}
            onChange={(e) => setEditMetaTitle(e.target.value)}
            multiline
            minRows={1}
            maxRows={2}
            sx={{ mb: 3 }}
            InputProps={{ style: { fontSize: 15, lineHeight: 1.6 } }}
          />
          <TextField
            fullWidth
            label="Meta Description"
            value={editMetaDescription}
            onChange={(e) => setEditMetaDescription(e.target.value)}
            multiline
            minRows={4}
            maxRows={8}
            sx={{ mb: 3 }}
            InputProps={{ style: { fontSize: 15, lineHeight: 1.7 } }}
          />
          <TextField
            fullWidth
            label="Meta Keywords (comma separated)"
            value={editMetaKeywords}
            onChange={(e) => setEditMetaKeywords(e.target.value)}
            multiline
            minRows={3}
            maxRows={6}
            sx={{ mb: 3 }}
            InputProps={{ style: { fontSize: 15, lineHeight: 1.7 } }}
          />

          <Button
            variant="contained"
            fullWidth
            onClick={updateCategory}
            disabled={editLoading}
            sx={{ py: 1.3, fontSize: 16 }}
          >
            {editLoading ? "Updating..." : "Update"}
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default CategoryPage;